import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import "../styles/NotFound.css";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="notfound">
      <div className="notfound-container">
        <h1>404</h1>
        <p className="subtitle">Oops! Página não encontrada</p>
        <p className="description">
          A página que você tentou acessar não existe ou foi movida.
        </p>
        <a href="/" className="btn-home">
          Voltar para o Início
        </a>
      </div>
    </div>
  );
};

export default NotFound;
